import { useState, ChangeEvent, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Grow, Paper, Tab, Tabs } from "@material-ui/core";
import { TabContext, TabPanel } from "@material-ui/lab";
import Information from "./Module/Information";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CollaboratorContext, {
} from "../../../context/CollaboratorContext/CollaboratorContext";
import CheckPermission from "../../../helpers/Administradores/Permissions";

const BodyCreateCollaborator = () => {
  const [value, setValue] = useState<string>("1");
  const params = useParams<any>();
  const history = useHistory();
  const { state } = useContext(CollaboratorContext);

  const handleChange = (event: ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
    history.push(`${newValue}`);
  };

  return (
    <TabContext value={value}>
      <Tabs
        value={value}
        onChange={handleChange}
        className={
          Math.round(state.progress[Number(value) - 1]) >= 100
            ? `collaborator filledAll`
            : `collaborator`
        }
        scrollButtons="auto"
        variant="fullWidth"
      >
        <Tab
          icon={Math.round(state.progress[0]) >= 100 ? <CheckCircleIcon /> : ""}
          label={"Información de alta"}
          value="1"
          className={
            value === "1"
              ? "Tab__SelectedFirst Tab__Selected"
              : Math.round(state.progress[0]) >= 100
              ? "Tab__SelectedFirst Tab__Selected Tab__background filledAll"
              : "Tab__NoSelected Tab__NoSelectedFirst"
          }
        />
        <Tab
          icon={state.progress[1] >= 100 ? <CheckCircleIcon /> : ""}
          label="Datos Personales"
          value="2"
          className={
            value === "2"
              ? "Tab__Selected"
              : Math.round(state.progress[1]) >= 100
              ? "Tab__Selected Tab__background filledAll"
              : "Tab__NoSelected"
          }
          disabled={
            params.id !== "id" && params.id !== "new"
              ? state.band && state.collaborator?.status === "sent"
                ? true
                : state.collaborator?.status === "sent"
                ? true
                : false
              : true
          }
        />
        <Tab
          icon={state.progress[2] >= 100 ? <CheckCircleIcon /> : ""}
          label="Salud y Emergencias"
          value="3"
          className={
            value === "3"
              ? "Tab__Selected"
              : Math.round(state.progress[2]) >= 100
              ? "Tab__Selected Tab__background filledAll"
              : "Tab__NoSelected"
          }
          disabled={
            params.id !== "id" && params.id !== "new"
              ? state.band && state.collaborator?.status === "sent"
                ? true
                : state.collaborator?.status === "sent"
                ? true
                : false
              : true
          }
        />
        <Tab
          icon={state.progress[3] >= 100 ? <CheckCircleIcon /> : ""}
          label="Datos para el pago"
          value="4"
          className={
            value === "4"
              ? "Tab__Selected"
              : Math.round(state.progress[3]) >= 100
              ? "Tab__Selected Tab__background filledAll"
              : "Tab__NoSelected"
          }
          disabled={
            params.id !== "id" && params.id !== "new"
              ? state.band && state.collaborator?.status === "sent"
                ? true
                : state.collaborator?.status === "sent"
                ? true
                : false
              : true
          }
        />
        <Tab
          icon={state.progress[4] >= 100 ? <CheckCircleIcon /> : ""}
          label="Expediente"
          value="5"
          className={
            value === "5"
              ? "Tab__Selected Tab__Selectedlast"
              : Math.round(state.progress[4]) >= 100
              ? "Tab__Selected Tab__background filledAll Tab__NoSelectedLast"
              : "Tab__NoSelected Tab__NoSelectedLast"
          }
          disabled={
            params.id !== "id" && params.id !== "new"
              ? state.band && state.collaborator?.status === "sent"
                ? true
                : state.collaborator?.status === "sent"
                ? true
                : false
              : true
          }
        />
      </Tabs>
      <div className="collaborator__candidate__container">
        <Grow in={true}>
          <Paper>
            {CheckPermission("Colaboradores.NuevoIngreso.Ver.InformacionAlta") && (
              <TabPanel value="1">{value === "1" && <Information />}</TabPanel>
            )}
          </Paper>
        </Grow>
      </div>
    </TabContext>
  );
};

export default BodyCreateCollaborator;
